module.exports = __webpack_public_path__ + "img/banner-1.5k.f2019c12.svg";